module.exports = __webpack_public_path__ + "static/media/authentication.77db97a8.PNG";